import apiClient from './api';
import { adminService } from './adminService';
import type { RacingRuleSection, RacingRulesVersion, ExtractionStatus } from '../types';

/**
 * Service module for Racing Rules of Sailing API operations.
 * Uses presigned URL upload flow (same as IRC rules).
 */

export const racingRulesService = {
  uploadRacingRules: async (
    file: File,
    effectiveDate: string
  ): Promise<{ versionId: string; status: string }> => {
    const result = await adminService.uploadGlobalDocument(file, 'racing_rules');
    return {
      versionId: result.documentId,
      status: 'processing',
    };
  },

  getExtractionStatus: async (): Promise<ExtractionStatus> => {
    const response = await apiClient.get<ExtractionStatus>(
      '/admin/racing-rules/status'
    );
    return response.data;
  },

  getVersionInfo: async (): Promise<RacingRulesVersion | null> => {
    const response = await apiClient.get<RacingRulesVersion & { version?: null }>(
      '/admin/racing-rules/version'
    );
    if ('version' in response.data && response.data.version === null) {
      return null;
    }
    return response.data as RacingRulesVersion;
  },

  listSections: async (
    filters?: { part?: string }
  ): Promise<RacingRuleSection[]> => {
    const params: Record<string, string> = {};
    if (filters?.part) {
      params.part = filters.part;
    }
    const response = await apiClient.get<{ sections: RacingRuleSection[] }>(
      '/racing-rules/sections',
      { params }
    );
    return response.data.sections;
  },

  deleteVersion: async (versionId: string): Promise<{ message: string }> => {
    const response = await apiClient.delete<{ message: string }>(
      `/admin/racing-rules/${encodeURIComponent(versionId)}`
    );
    return response.data;
  },
};
